module.exports = __webpack_public_path__ + "img/photo1_2.78c23db4.jpg";